'use strict';

var React = require('react');

var SvgFolderMinusMajor = function SvgFolderMinusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3a1.5 1.5 0 0 1 1.5 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h4.879a1.5 1.5 0 0 1 1.06.44l1.122 1.12a1.5 1.5 0 0 0 1.06.44h6.879zm-10.5 7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6z"
  }));
};

exports.SvgFolderMinusMajor = SvgFolderMinusMajor;
